var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"echart-box"},[_c('div',{ref:"chartContainer",staticStyle:{"margin-top":"7%","width":"790px","height":"400px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }